import React from 'react'

export default function Footer() {
  return (
    <footer className="footer">
      <div className="content has-text-centered">
        <p>
           The source code is licensed MIT. The website content is licensed CC BY NC SA 4.0.
        </p>
      </div>
    </footer>
  )
}
